import React from 'react';
import { BenefitsSectionProps } from '../../types/solution';
import OptimizedImage from '../about/OptimizedImage';

const BenefitsSection: React.FC<BenefitsSectionProps> = ({ data, items }) => {
  if (!data && (!items || items.length === 0)) {
    return <div>Loading benefits section...</div>;
  }

      
  
  const leftColumnItems = items?.slice(0, 3) || [];
  const rightColumnItems = items?.slice(3, 6) || [];

  return (
    <section id="benefitssection" className="benefitssection section mt-0 dark-background bg-blue">
      <div className="container" data-aos="fade-up">
        <div className="row px-1 gx-3">
          <div className="offset-md-1 col-md-10 section-title pb-2 text-center">
            <h2>{data?.field_description?.[0]?.value}</h2>
            <p 
              className="py-2"
              dangerouslySetInnerHTML={{ __html: data?.field_content?.[0]?.value || '' }} 
            />
            
            <div className="row gx-2 text-start mt-2">
              {/* Left Column */}
              <div className="col-lg-6 col-sm-12">
                <h3 className="mb-3">{data?.field_sub_title?.[0]?.value}</h3>
                {leftColumnItems.map((item, index) => (
                  <div key={index} className="divBenefits d-flex">
                    <div className="img-holder text-center" data-aos="zoom-out" data-aos-delay="100">
                      {item.image && (
                        <img
                          src={item.image?.thumbnail?.[0]?.url}
                          className="img-fluid"
                          alt={`Benefit ${index + 1}`}
                          loading="lazy"
                        />
                      )}
                    </div>
                    <h6 data-aos="fade-in" data-aos-delay="100">{item.title}</h6>
                  </div>
                ))}
              </div>

              {/* Right Column */}
              <div className="col-lg-6 col-sm-12">
                <h3 className="mb-3">{data?.field_sub_title?.[1]?.value}</h3>
                {rightColumnItems.map((item, index) => (
                  <div key={index} className="divBenefits d-flex">
                    <div className="img-holder" data-aos="zoom-out" data-aos-delay="100">
                      {item.image && (
                        <img
                          src={item.image?.thumbnail?.[0]?.url}
                          className="img-fluid mx-auto"
                          alt={`Benefit ${index + 4}`}
                          loading="lazy"
                        />
                      )}
                    </div>
                    <h6>{item.title}</h6>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
